export default __webpack_public_path__ + "static/media/4.3c22b4da.webp";